var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5890_12360",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.5234,
    y: 0.473633,
    width: 15.0526,
    height: 15.0526,
    transform: "rotate(90 15.5234 0.473633)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5890_12360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.22911 7.73391L6.78306 5.28785C6.66807 5.17287 6.61058 5.02652 6.61058 4.84882C6.61058 4.67111 6.66807 4.52477 6.78306 4.40978C6.89804 4.2948 7.04439 4.2373 7.22209 4.2373C7.3998 4.2373 7.54614 4.2948 7.66113 4.40978L10.5462 7.29487C10.6717 7.42031 10.7344 7.56665 10.7344 7.73391C10.7344 7.90116 10.6717 8.0475 10.5462 8.17294L7.66113 11.058C7.54614 11.173 7.3998 11.2305 7.22209 11.2305C7.04439 11.2305 6.89804 11.173 6.78306 11.058C6.66807 10.943 6.61058 10.7967 6.61058 10.619C6.61058 10.4413 6.66807 10.2949 6.78306 10.18L9.22911 7.73391Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDetails);
export default __webpack_public_path__ + "static/media/arrow-details.7a4efb6080c4db29f6258d88018c0ea1.svg";
export { ForwardRef as ReactComponent };